import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaUsers, FaClock, FaAward } from 'react-icons/fa';
import { getHakkimizda, getSiteBilgileri } from '../services/api';
import './Hakkimizda.css';

const Hakkimizda = () => {
  const [bilgi, setBilgi] = useState(null);
  const [ayar, setAyar] = useState(null);

  useEffect(() => {
    getHakkimizda()
      .then(res => {
        const data = res.data.results || res.data;
        if (Array.isArray(data) && data.length > 0) {
          setBilgi(data[0]);
        }
      })
      .catch(err => console.error(err));

    getSiteBilgileri()
      .then(res => setAyar(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="hakkimizda-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>Hakkımızda</h1>
          <p>Karpat Otomotiv'i daha yakından tanıyın</p>
        </div>
      </section>

      <section className="hakkimizda-content">
        <div className="container">
          <div className="hakkimizda-grid">
            <div className="hakkimizda-text">
              <h2>Karpat Otomotiv</h2>
              <p>
                {bilgi?.icerik || 
                  'Karpat Otomotiv olarak yıllardır otomotiv sektöründe güvenilir ve kaliteli hizmet sunmaktayız. Uzman kadromuz ve modern ekipmanlarımızla aracınıza en iyi bakımı sağlıyoruz. Müşteri memnuniyetini her zaman ön planda tutarak, şeffaf ve dürüst hizmet anlayışımızla sektörde fark yaratıyoruz.'}
              </p>
              <ul className="hakkimizda-list">
                <li><FaCheckCircle /> Uzman ve deneyimli teknik kadro</li>
                <li><FaCheckCircle /> Modern ekipman ve teknoloji</li>
                <li><FaCheckCircle /> Uygun fiyat garantisi</li>
                <li><FaCheckCircle /> Hızlı ve güvenilir hizmet</li>
                <li><FaCheckCircle /> Tüm marka ve modellere hizmet</li>
                <li><FaCheckCircle /> Garanti kapsamında işçilik</li>
              </ul>
            </div>
            <div className="hakkimizda-image">
              <div className="image-placeholder">
                <FaAward className="placeholder-icon" />
                <span>{ayar?.istatistik_1_sayi || '15+'} {ayar?.istatistik_1_etiket || 'Yıllık Deneyim'}</span>
              </div>
            </div>
          </div>

          <div className="hakkimizda-stats">
            <div className="stat-item">
              <FaClock className="stat-icon" />
              <span className="stat-number">{ayar?.istatistik_1_sayi || '15+'}</span>
              <span className="stat-label">{ayar?.istatistik_1_etiket || 'Yıllık Deneyim'}</span>
            </div>
            <div className="stat-item">
              <FaUsers className="stat-icon" />
              <span className="stat-number">{ayar?.istatistik_2_sayi || '5000+'}</span>
              <span className="stat-label">{ayar?.istatistik_2_etiket || 'Mutlu Müşteri'}</span>
            </div>
            <div className="stat-item">
              <FaCheckCircle className="stat-icon" />
              <span className="stat-number">{ayar?.istatistik_3_sayi || '12000+'}</span>
              <span className="stat-label">{ayar?.istatistik_3_etiket || 'Tamamlanan İş'}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hakkimizda;
